import { getTaskTemplateFromDto, getTaskTemplateLiteFromDto, } from "../components/shared/domainTypes/task/taskTemplate.type";
import Fetcher from "./FetchService";
import { getTaskFromDto, } from "../components/shared/domainTypes/task/task.type";
// Cache the response from the fetchAreResourcesActive service call.
let fetchAreResourcesActiveCache;
class TaskService {
    static validateTaskTemplate(template, isInActionPlan) {
        // Make sure this template has a title.
        if (!template.title) {
            return { isValid: false, errorMessage: "Template is missing title." };
        }
        // Make sure this template has a prioirty
        if (!template.priority) {
            return { isValid: false, errorMessage: "Template is missing priority." };
        }
        // If this template is used in an action plan, it needs to have an assigned person.
        if (template.usages &&
            Object.keys(template.usages).length &&
            !template.assignedPerson) {
            return {
                isValid: false,
                errorMessage: "Because this template is used in an Action Plan Template, it needs an assigned person. " +
                    "Either give this template an assigned person or remove it from the following action plan(s): " +
                    Object.values(template.usages)
                        .map((usage) => usage.actionPlanTemplate.templateTitle)
                        .join(", "),
            };
        }
        if (isInActionPlan && !template.assignedPerson) {
            return {
                isValid: false,
                errorMessage: "Action Plan Template requires Task Template to have at least one assignee.",
            };
        }
        return { isValid: true };
    }
    static validateActionPlanTemplate(template) {
        // Make sure this template has a title
        if (!template.title) {
            return {
                isValid: false,
                errorMessage: "Action Plan Template must have a title.",
            };
        }
        // Make sure this template has a priority
        if (!template.priority) {
            return {
                isValid: false,
                errorMessage: "Action Plan Template must have a priority.",
            };
        }
        // Make sure the action plan has at least one task template
        if (!template.templates.length) {
            return {
                isValid: false,
                errorMessage: "Action Plan Template must have at least one Task Template.",
            };
        }
        // Make sure all this action plan template's task templates are valid too.
        const invalidTemplateValidations = template.templates
            .map((taskTemp) => ({
            temp: taskTemp,
            valid: TaskService.validateTaskTemplate(taskTemp, true),
        }))
            .filter((item) => !item.valid.isValid);
        if (invalidTemplateValidations.length) {
            return {
                isValid: false,
                errorMessage: "Invalid task templates: " +
                    invalidTemplateValidations
                        .map((item) => `"${item.temp.templateTitle || item.temp.title || "No Title"}" - ${item.valid.errorMessage}`)
                        .join(", "),
            };
        }
        return { isValid: true };
    }
    static getTaskTemplates(max = 0, page = 0, order = "asc", sort = "title") {
        return Fetcher.getSingleResponse("/aviso/taskAdmin/templates", {
            max,
            page,
            order,
            sort,
        }).then((data) => ({
            totalCount: data.totalCount,
            templates: data.templates.map(getTaskTemplateFromDto),
        }));
    }
    static getAssignedPeople(search = "", max = 0) {
        return Fetcher.get("/aviso/task/peopleThatCanAccessTasks", {
            query: search,
            max,
        });
    }
    static getAssociatedPeople(search = "", max = 0) {
        return Fetcher.getSingleResponse("/aviso/task/peopleThatCanBeAssociated", {
            query: search,
            max,
        });
    }
    static getResources(search = "", max = 0) {
        return Fetcher.getSingleResponse("/aviso/task/getListOfResourcesForTasks", {
            query: search,
            max,
        });
    }
    static getAssignedPersonPrototypes() {
        return Fetcher.getSingleResponse("/aviso/taskAdmin/assignedPeopleProtos");
    }
    static getTaskTemplatesWithUsages(search = "", max = 10) {
        return Fetcher.getSingleResponse("/aviso/taskAdmin/taskTemplatesWithUsages", {
            query: search,
            max,
        });
    }
    static getTasksAssignedToPerson(personId, taskStatusIds = []) {
        return Fetcher.getSingleResponse("/aviso/taskAdmin/getTasksAssignedToPerson", { personId, taskStatusIds }).then((dtos) => dtos.map(getTaskFromDto));
    }
    static getTemplatesAssignedToPerson(personId, includeTempsInActionPlans) {
        return Fetcher.getSingleResponse("/aviso/taskAdmin/getTemplatesAssignedToPerson", { personId, includeTempsInActionPlans }).then((dtos) => dtos.map(getTaskTemplateLiteFromDto));
    }
    static getPeopleAssignedToTasks(search = "", max = 10) {
        return Fetcher.getSingleResponse("/aviso/taskAdmin/getPeopleAssignedToTasks", { query: search, max });
    }
    static getPeopleAssignedToTemplates(search = "", max = 10) {
        return Fetcher.getSingleResponse("/aviso/taskAdmin/getPeopleAssignedToTemplates", { query: search, max });
    }
    static fetchAreResourcesActive() {
        if (!fetchAreResourcesActiveCache) {
            fetchAreResourcesActiveCache = Fetcher.getSingleResponse("/aviso/resource/isActive").then(({ isActive }) => isActive);
        }
        return fetchAreResourcesActiveCache;
    }
}
/*
 * Returns the number of action plans this template is used in, not including this one.
 */
TaskService.getNumberOfActionPlansTemplateUsedIn = (template, actionPlanIdsToExclude = new Set()) => template.usages
    ? Object.keys(template.usages).filter((planId) => !actionPlanIdsToExclude.has(parseInt(planId, 10))).length
    : 0;
export default TaskService;
